import {Model} from "./base/Model";
import {Collection} from "./base/Collection";

    export class Worklog extends Model  {
        logs: Collection = new Collection([]);
        constructor(data = null) {
            super(data);
            if(data) {
                this.createModel(data);
                if(Array.isArray(this.logs)) {
                    this.logs = new Collection([]);
                }
            }
        }      
      
    }